/* eslint-disable import/prefer-default-export */
export const THEMES = {
	LIGHT: 'light',
	ONE_DARK: 'dark',
};
